import { PathTrigger } from "../popover.context";

type Props = {
    trigger: PathTrigger;
};

export const PathCard = ({ trigger }: Props) => {
    return (
        <div>
            <i style={{ marginTop: 0 }}>{trigger.path !== null ? "Follow the path" : "Path not found"}</i>
        </div>
    );
};
